import axiosClient from './client';

export const createPlaidPublicToken = (id) => (
  axiosClient().post(`/tracked_account_providers/${id}/plaid_public_token`)
)

export const reconnect = (id) => (
  axiosClient().put(`/tracked_account_providers/${id}/reconnect`)
)
